<template>
    <section>
        <inline-advice :expandable="false">
            <div slot="title"> {{ title }} </div>
            <div slot="text"> 
                {{ equipment.advice }} 
                <span v-if="name === 'Smoke Communicator'">Look at our <router-link to="/assessment/help/smoke-communicator-guide">
                    Smoke communicator guide
                </router-link>.</span>
                <span v-if="name === 'Carbon Monoxide Communicator'">Look at our <router-link to="/assessment/help/carbon-monoxide-communicator-guide">
                    Carbon Monoxide communicator guide
                </router-link>.</span>
            </div>
            <div class="inlineAdviceEquipment">
                <div class="learnMore">
                    <!-- <router-link :to="helpEquipmentLink(equipment.name)">Learn more about {{ plural }}</router-link> -->
                </div>
                <div class="equipmentImage">
                    <img :src="equipment.image"
                         :alt="equipment.name">
                </div>
                <div class="equipmentQuantity">You have {{ qty }} {{ qty !== 1 ? plural : name }}</div>
                <div class="equipmentTotal" v-if="price !== 0">${{ price }}</div>
                <div class="equipmentTotal" v-if="price === 0">Select quantity</div>
                <AutomationQuantityAdjuster :name="name"
                                          :plural="plural"
                                          :theKey="theKey"
                                          :equipment="equipment" />
                <div class="equipmentActionRow">
                    <div class="true-advice-inline-bottom-actions"
                         v-show="!automationInterestsToRemove[theKey]">
                            <a href="javascript:;"
                               @click="stageRemoval(theKey)">Remove</a>
                    </div>
                    <div class="true-advice-inline-bottom-actions"
                         v-if="automationInterestsToRemove[theKey]">
                        <div class="no"
                             @click="unstageRemoval(theKey)">
                            <a href="javascript:;"
                               class="btn btn-primary">No</a>
                        </div>
                        <div class="yes"
                             @click="removeInterest(theKey)">
                            <a href="javascript:;"
                               class="btn">Yes, remove it</a>
                        </div>
                    </div>
                </div>
            </div>
        </inline-advice>
    </section>
</template>


<script>
import { mapActions, mapState } from "vuex";
import AutomationQuantityAdjuster from "../components/InterestedEquipmentAdjuster.vue";
export default {
  components: {
    AutomationQuantityAdjuster
  },
  props: ["name", "theKey", "more", "equipment", "plural"],
  computed: {
    ...mapState([
      "automationInterestsMore",
      "automationInterestsToRemove",
      "lead",
      "environmentalRecommendations"
    ]),

    title() {
      let fireCount = this.environmentalRecommendations["Fire"];
      let coCount = this.environmentalRecommendations["CarbonMonoxide"];
      let fireEquipment =
        fireCount === 1 ? "smoke communicator" : "smoke communicators";
      let coEquipment =
        coCount === 1
          ? "carbon monoxide communicator"
          : "carbon monoxide communicators";

      if (this.name == "Smoke Communicator") {
        return `We recommend ${fireCount} ${fireEquipment}`;
      }

      if (this.name == "Carbon Monoxide Communicator") {
        return `We recommend ${coCount} ${coEquipment}`;
      }

      return this.name;
    },

    price() {
      let qty = this.lead.automationQuantities[this.theKey];
      let price = this.equipment.price;
      return qty * price;
    },

    qty() {
      let qty = this.lead.automationQuantities[this.theKey];
      return qty;
    },

    showAdjuster() {
      let interestedKey = this.theKey.replace(/([A-Z])/g, " $1").trim();
      // if (this.theKey === 'CarbonMonoxide') {
      //     interestedKey = 'Carbon Monoxide'
      // }
      // if (this.theKey === 'LowTemperature') {
      //     interestedKey = 'Low Temperature'
      // }
      let interested = this.isInterested(interestedKey);
      let wantsMore = this.automationInterestsMore[this.theKey];
      return interested && wantsMore;
    }
  },
  methods: {
    ...mapActions([
      "removeAutomationInterest",
      "removeAdditionalThreat",
      "wantsMoreAutomation"
    ]),

    stageRemoval(theKey) {
      this.$store.state.automationInterestsToRemove[theKey] = true;
    },

    unstageRemoval(theKey) {
      this.$store.state.automationInterestsToRemove[theKey] = false;
    },

    isInterested(name) {
      let inAutomation = this.lead.automationInterests.includes(name);
      let inAdditionalThreats = this.lead.additionalThreats.includes(name);
      return inAutomation || inAdditionalThreats;
    },

    removeInterest(theKey) {
      // Add Space to Pascal Case
      theKey = theKey.replace(/([A-Z])/g, " $1").trim();
      let threats = ["Fire", "Carbon Monoxide", "Low Temperature", "Flooding"];
      if (threats.indexOf(theKey) > -1) {
        this.removeAdditionalThreat(theKey);
        return;
      }
      this.removeAutomationInterest(theKey);
    },

    helpEquipmentLink(name) {
      let slug = encodeURI(name);
      return `/assessment/help/equipment?name=${slug}`;
    }
  }
};
</script>

<style lang="css"></style>
